export const baseURL = process.env.REACT_APP_MAIN_BASE_URL

export const faceRecognitionAPIBaseURL = process.env.REACT_APP_FACE_RECOGNITION_API_BASE_URL
export const faceRecognitionModelURL = process.env.REACT_APP_FACE_RECOGNITION_MODEL_URL

export const radarAPIURL = process.env.REACT_APP_RADAR_API_BASE_URL
export const radarSKAPIKey = process.env.REACT_APP_RADAR_SK_API_KEY
export const radarPKAPIKey = process.env.REACT_APP_RADAR_PK_API_KEY

export const googleMapAPIKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY

export const timeZoneURL = baseURL + '/getTimezones'
export const userURL = baseURL + '/user'
export const departmentURL = baseURL + '/department'
export const rolesURL = baseURL + '/roles'
export const userShiftURL = baseURL + '/usershift'
export const contractorURL = baseURL + '/contractor'
export const employeeURL = baseURL + '/employee'
export const employeeTypeURL = baseURL + '/employeeType'
export const userInOutURL = baseURL + '/inout'
export const functionalityURL = baseURL + '/functionality'
export const moduleURL = baseURL + '/module'
export const actionURL = baseURL + '/actions'
export const fileUploadURL = baseURL + '/uploadFile'
export const locationURL = baseURL + '/location'
export const companyDetailsURL = baseURL + '/companyDetails'
export const companyThemeURL = baseURL + '/companyTheme'
export const companyEmployeeURL = baseURL + '/companyEmployee'
export const employeeRoleURL = baseURL + '/employeeRole'
export const employeeRoleActionURL = baseURL + '/companyRoleActions'

export const employeeTextInfoURL = baseURL + '/employeeTextInfo'
export const employeeBankInfoURL = baseURL + '/employeeBankInfo'
export const employeeEarningsURL = baseURL + '/employeeEarnings'
export const employeePayrollInfoURL = baseURL + '/employeePayrollInfo'
export const employmentInfoURL = baseURL + '/employmentInfo'
export const companyShiftURL = baseURL + '/companyShift'
export const companyFunctionalityURL = baseURL + '/companyFunctionality'
export const companyModuleURL = baseURL + '/companyModule'
export const companyActionsURL = baseURL + '/companyActions'
export const overtimeRulesURL = baseURL + '/overtimerules'
export const employeeSalaryStatementURL = baseURL + '/employee/statement'
export const salaryStatementHistoryURL = baseURL + '/salaryStatementHistory'
export const statementMasterURL = baseURL + '/statementMaster'
export const weeklyOffURL = baseURL + '/weekly-off'
export const attendancePenaltyRulesURL = baseURL + '/attendancePenaltyRules'
export const holidayTemplatesURL = baseURL + '/holidayTemplates'
export const holidayTemplateDetailsURL = baseURL + '/holidayTemplateDetails'
export const deductionsURL = baseURL + '/deductions'
export const leaveTypeURL = baseURL + '/leaveType'
export const employeeLeaveMasterURL = baseURL + '/employeeLeaveMaster'


export const countryURL = baseURL + '/country'
export const stateURL = baseURL + '/state'
